import { Component, OnChanges, OnInit, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { BankService } from '../../service/data/bank.service';
import { Bank } from '../../model/bank';
import { FormGroup } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';

@Component({
    selector: 'app-bank-account',
    templateUrl: './bank-account.component.html',
    styleUrls: ['./bank-account.component.scss'],
    providers: [BankService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BankAccountComponent implements OnChanges, OnInit {
  constructor(
    private _dataService: BankService,
    private _fcf: FormControlExFactory
  ) {}

  @Input() dataContext: string;
  @Input() form: FormGroup;

  private _banks: Bank[];
  bankAccountMask = /^(\d{4}\-\d{0,10})|(\d{1,4})/;
  bankName: string = null;

  private _updateBankName(bankAccount: string) {
    if (!bankAccount || bankAccount.length < 4) {
      this.bankName = null;
    } else {
      const clearingNumber = parseInt(bankAccount.substring(0, 4));
      let banks = this._banks.filter(x => clearingNumber >= x.clearingNumberFrom && clearingNumber <= x.clearingNumberTo);
      if (banks.length > 0) {
        this.bankName = banks[0].name;
      }
    }
  }

  get hasBankAccount(): boolean {
    return this.bankName !== null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataContext'] && this.form.contains('bankAccount')) {
      this.form.controls['bankAccount'].setValue(this.dataContext);
    }
  }

  ngOnInit() {
    this.form.addControl('bankAccount', this._fcf.create('TENANT.BANK_ACCOUNT_NUMBER', this.dataContext));
    this.form.controls['bankAccount'].valueChanges.subscribe(value => this._updateBankName(value));
    this._dataService.get().subscribe(data => {
      this._banks = data;
      this._updateBankName(this.dataContext);
    });
  }
}
